<template>
  <div class="fill-height of-y d-flex flex-column">
    
    
    <div class="d-flex align-center justify-center fill-height flex-column" v-if="!selectedFarm">
      <v-icon x-large class="mb-4 grey--text">mdi-tractor-variant</v-icon>
      <span class="grey--text text-h6">Please select a farm to continue</span>
    </div>
    
    <template v-else>
      <div class="flex-grow-0 pa-2 d-flex justify-space-between">
        <v-btn
            :disabled="false"
            @click="exportReportData"
            color="primary"
            small
            :loading="exportingData"
        >
          Export
        </v-btn>
        <div class="flex-grow-1">
        
        </div>
        <div style="width: 30%">
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="pa-0 ma-0"
          ></v-text-field>
        </div>
        <!--                <div>-->
        <!--                    <v-btn-->
        <!--                            icon-->
        <!--                            color="primary"-->
        <!--                            class="pa-0 mr-2"-->
        <!--                            @click="$emit('update:selected-date', subDays(selectedDate, 1))"-->
        <!--                    >-->
        <!--                        <v-icon>mdi-chevron-left</v-icon>-->
        <!--                    </v-btn>-->
        <!--                    <v-btn-->
        <!--                            icon-->
        <!--                            color="primary"-->
        <!--                            class="pa-0 mr-2"-->
        <!--                            @click="$emit('update:selected-date', addDays(selectedDate, 1))"-->
        <!--                    >-->
        <!--                        <v-icon>mdi-chevron-right</v-icon>-->
        <!--                    </v-btn>-->
        <!--                </div>-->
      </div>
      <div v-if="loading" class="flex-grow-1 d-flex align-center justify-center">
        <loader></loader>
      </div>
      <div v-else class="flex-grow-1 of-y">
        <v-data-table
            :search="search"
            dense
            fixed-header
            height="100%"
            class="fill-height of-y"
            hide-default-footer
            :headers="headers"
            :items="data"
            :options="{itemsPerPage: data.length}"
        >
          <template #item.actions="{ item }">
            <v-btn
                icon
                small
                color="primary"
                @click="editShiftValue(item)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </template>
    
    <!-- Edit Dialog -->
    <v-dialog v-model="editDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Shift Value</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                    v-model="editedItem.empName"
                    label="Employee"
                    readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                    v-model="editedItem.timeInDate"
                    label="Date"
                    type="date"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                    v-model="editedItem.timeInTime"
                    label="Start Time"
                    type="time"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                    v-model="editedItem.timeOutDate"
                    label="End Date"
                    type="date"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                    v-model="editedItem.timeOutTime"
                    label="End Time"
                    type="time"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeEditDialog">
            Cancel
          </v-btn>
          <v-btn 
              color="blue darken-1" 
              text 
              @click="saveShiftValue"
              :loading="saving"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  
  </div>
</template>

<script>

import {addDays, endOfWeek, format, startOfWeek, subDays} from "date-fns";
import {mapGetters} from "vuex";
import Loader from "../General/Loader/Loader";

export default {
  components: {Loader},
  props: {
    selectedFarm: Number,
    selectedDate: Date
  },
  data() {
    return {
      search: null,
      headers: [
        {text: "Date", value: "date"},
        {text: "Shift", value: "shift"},
        {text: "Employee", value: "empName"},
        {text: "Clock No.", value: "clockNo"},
        {text: "Duration", value: "shiftEndDuration"},
        {text: "Duration Actual", value: "shiftEndDurationActual"},
        {value: "startTime", text: "Shift Start"},
        {value: "endTime", text: "Shift End"},
        {value: "endTimeActual", text: "Shift End Actual"},
        {text: "Actions", value: "actions", sortable: false, width: "100px"},
      ],
      data: [],
      addDays: addDays,
      subDays: subDays,
      exportingData: false,
      loading: false,
      editDialog: false,
      saving: false,
      editedItem: {
        fkEmp: null,
        empName: '',
        timeInDate: '',
        timeInTime: '',
        timeOutDate: '',
        timeOutTime: '',
        timeIn: null,
        timeOut: null
      },
      
    }
  },
  mounted() {
    if (this.selectedFarm && this.selectedDate)
      this.getData()
  },
  watch: {
    selectedFarm(val) {
      if (val) {
        this.getData()
      }
    },
    selectedDate(val) {
      if (val) {
        this.getData()
      }
    }
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.data = await this.$newReq('POST', `reports/shiftValues`, {
          farm: this.selectedFarm,
          start: this.selectedDate
        })
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError();
      } finally {
        this.loading = false
      }
    },
    exportReportData() {
      this.exportingData = true;
      
      const startDate = startOfWeek(new Date(this.selectedDate), {weekStartsOn: 1})
      const endDate = endOfWeek(new Date(this.selectedDate), {weekStartsOn: 1})
      
      this.$newReqDownloadFile(
          'POST',
          `reports/shiftValues/export`,
          {
            start: this.selectedDate,
            farm: this.selectedFarm,
            farmDescription: this.farm.description
          },
          `${this.farm.description} Shift Report ${format(startDate, 'MM-dd')} - ${format(endDate, 'MM-dd')}.xlsx`
      )
          .then(data => {
            console.log(data)
          })
          .catch(e => {
            console.log(e)
            this.$snack.netWorkError();
          })
          .finally(() => {
            this.exportingData = false
          })
    },
    editShiftValue(item) {
      console.log('Editing item:', item);
      
      let timeInDate = '';
      let timeInTime = '';
      let timeOutDate = '';
      let timeOutTime = '';
      
      if (item.shiftStart) {
        const timeIn = new Date(item.shiftStart);
        if (!isNaN(timeIn.getTime())) {
          timeInDate = timeIn.toISOString().split('T')[0];
          timeInTime = timeIn.toTimeString().split(' ')[0].substring(0, 5);
        }
      }
      
      if (item.shiftEndActual && item.shiftEndActual !== item.shiftStart) {
        const timeOut = new Date(item.shiftEndActual);
        if (!isNaN(timeOut.getTime())) {
          timeOutDate = timeOut.toISOString().split('T')[0];
          timeOutTime = timeOut.toTimeString().split(' ')[0].substring(0, 5);
        }
      }
      
      this.editedItem = {
        fkEmp: item.fkEmp,
        fkShift: item.fkShift,
        deviceId: item.deviceId,
        empName: item.empName,
        timeInDate,
        timeInTime,
        timeOutDate,
        timeOutTime,
        timeIn: item.shiftStart,
        timeOut: item.shiftEndActual !== item.shiftStart ? item.shiftEndActual : null
      };
      
      this.editDialog = true;
    },
    closeEditDialog() {
      this.editDialog = false;
      this.editedItem = {
        fkEmp: null,
        empName: '',
        timeInDate: '',
        timeInTime: '',
        timeOutDate: '',
        timeOutTime: '',
        timeIn: null,
        timeOut: null
      };
    },
    async saveShiftValue() {
      try {
        this.saving = true;
        
        const timeIn = format(new Date(`${this.editedItem.timeInDate}T${this.editedItem.timeInTime}`), 'yyyy-MM-dd HH:mm');
        const timeOut = this.editedItem.timeOutDate && this.editedItem.timeOutTime 
          ? format(new Date(`${this.editedItem.timeOutDate}T${this.editedItem.timeOutTime}`), 'yyyy-MM-dd HH:mm')
          : null;
        
        const payload = {
          fkEmp: this.editedItem.fkEmp,
          fkShift: this.editedItem.fkShift,
          deviceId: this.editedItem.deviceId,
          timeIn: timeIn,
          timeOut: timeOut ? timeOut : null
        };
        
        await this.$newReq('POST', 'shifts/upsertValue', payload);
        
        this.$snack.info('Shift value updated successfully');
        this.closeEditDialog();
        await this.getData();
        
      } catch (e) {
        console.log(e);
        this.$snack.netWorkError();
      } finally {
        this.saving = false;
      }
    }
  },
  computed: {
    ...mapGetters(['farmsRef']),
    farm() {
      return this.selectedFarm ? this.farmsRef[this.selectedFarm] : null
    },
    // rows() {
    //     return this.data.map(row => {
    //         return {
    //             farmID: row.farm.id,
    //             farm: row.farm.description,
    //             employee: row.emp.fullName,
    //             empCode: row.emp.empCode,
    //             clockIn: row.clockInStr,
    //             lastAction: row.lastActionStr,
    //             binUnits: row.binUnits,
    //             piecework: row.pieceWorkStr,
    //             pWUnits: row.pieceWorkUnits,
    //             hours: row.hours,
    //         }
    //     }).filter((row) => this.selectedFarm ? row.farmID === this.selectedFarm : true)
    // }
  },
}
</script>

<style scoped>

</style>